import { OBJECT_SUMMARY } from '../../constants/CopilotInAppActionTypes';
const normalizeObjectType = objectTypeId => {
  switch (objectTypeId) {
    case '0-1':
      return 'CONTACT';
    case '0-2':
      return 'COMPANY';
    case '0-3':
      return 'DEAL';
    case '0-5':
      return 'TICKET';
    case '0-18':
      return 'COMMUNICATION';
    default:
      return objectTypeId;
  }
};
const parseObjectId = objectId => {
  try {
    return parseInt(objectId, 10);
  } catch (e) {
    return objectId;
  }
};
export const objectSummary = action => {
  return {
    data: {
      intent: OBJECT_SUMMARY,
      object_id: parseObjectId(action.objectId),
      object_type: normalizeObjectType(action.objectTypeId)
    },
    text: action.label ? `Summarize ${action.objectTypeLabel} ${action.label}` : `Tell me about the ${action.objectTypeLabel} I selected`
  };
};